<template>
    <div>
        <header class="masthead">
            <div class="h-100">
                <div class="row h-100 align-items-left">
                <div class="col-12 text-left">
                    <h1 class="font-weight-light" style="text-transform: capitalize;">Welcome, {{getUserName()}}</h1>
                </div>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
export default {
  name: 'Dashboard',
  methods:{
      getUserName() {
          var user = JSON.parse(localStorage.getItem('auth_user'));
          return user.firstname+' '+user.lastname;
      }
  }
};
</script>
